import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import { actions } from '../../../../context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';

const FilterUserAssignedPractices = () => {
    const dispatch = useDispatch();
    // bool tied to the filter assigned practices button
    const onlyShowAssigned = useSelector(state => state.practice.onlyShowAssigned);

    const buttonTitle = onlyShowAssigned ? `Show all practices` : `Filter assigned practices`;

    const getButtonClasses = (isActive) => isActive ? 'text-light bg-primary' : 'text-primary bg-light';

    const buttonClasses = `rounded-circle ${getButtonClasses(onlyShowAssigned)}`;

    const buttonHandler = () => dispatch(actions.practice.setOnlyShowAssigned(!onlyShowAssigned));

    const icon = useMemo(() => <FontAwesomeIcon icon={faUser} />, []);

    return (
        <Button title={buttonTitle} className={buttonClasses} onClick={buttonHandler}>
            {icon}
        </Button>
    );
};

export default React.memo(FilterUserAssignedPractices);